import React from 'react';

export function InboxArrowDown(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <path fill="currentColor" d="M5.833 8.333 10 12.5l4.167-4.167z"></path>
    </svg>
  );
}
